export default "__VITE_ASSET__DMbQ_Rjh__"